export default __webpack_public_path__ + "7ff498dc8c2a0027537ee457ed5b0323.svg";